import queryString from 'query-string';
import { generateQueryString } from '../utils/functions';

const useCommonFilters = (location, allowedFilters = [], options = {}) => {
  const {
    enableGlobalSearch = true,
    alwaysIncludePage = false,
    setSearchText = () => {}, // Legacy function support
    setSearchedColumn = () => {}, // Legacy function support
  } = options;

  const params = queryString.parse(location.search);

  const validateAndGetFilters = () => {
    const validFilters = {};
    allowedFilters.forEach(filter => {
      if (params[filter] && params[filter].trim()) {
        validFilters[filter] = params[filter].trim();
      }
    });
    return validFilters;
  };

  const updateFilters = newFilters => {
    const currentFilters = validateAndGetFilters();
    const updatedFilters = { ...currentFilters, ...newFilters };

    Object.keys(updatedFilters).forEach(key => {
      const value = updatedFilters[key];
      if (!value || (typeof value === 'string' && value.trim() === '')) {
        delete updatedFilters[key];
      }
    });

    const hasOtherFilters = Object.keys(updatedFilters).some(key => key !== 'page');

    let queryStr;
    if (alwaysIncludePage || !enableGlobalSearch) {
      queryStr = generateQueryString(
        ['page', updatedFilters.page || 1],
        ...Object.entries(updatedFilters).filter(([key]) => key !== 'page')
      );
    } else {
      queryStr = hasOtherFilters
        ? generateQueryString(...Object.entries(updatedFilters).filter(([key]) => key !== 'page'))
        : generateQueryString(['page', updatedFilters.page || 1]);
    }

    window.location.replace(`${location.pathname}${queryStr}`);
  };

  // Legacy handleSearch function for backward compatibility
  const handleSearch = (selectedKeys, dataIndex) => {
    setSearchText(selectedKeys?.[0]);
    setSearchedColumn(dataIndex);
    updateFilters({ [dataIndex]: selectedKeys?.[0] });
  };

  // Legacy handleReset function for backward compatibility
  const handleReset = clearFilters => {
    clearFilters && clearFilters();
    setSearchText('');
    window.location.replace(location.pathname);
  };

  const clearAllFilters = () => {
    window.location.replace(location.pathname);
  };

  return {
    filters: validateAndGetFilters(),
    updateFilters,
    clearAllFilters,
    clearFilters: clearAllFilters,
    currentPage: parseInt(params?.page) || 1,
    params,
    page: parseInt(params?.page) || 1,
    // Legacy functions for old code compatibility
    handleSearch,
    handleReset,
  };
};

export default useCommonFilters;
